export const subscriptionTitleKey = 'paymentFlow.alreadySubscriber.subscriptionTitle';
export const upsellTitleKey = 'paymentFlow.alreadySubscriber.upsellTitle';

export const subscriptionDescriptionKey = 'paymentFlow.alreadySubscriber.subscriptionSubTitle';
export const upsellDescriptionKey = 'paymentFlow.alreadySubscriber.upsellSubTitle';
